import React from "react";
import {message, Modal} from "antd";
import TooltipIcon from "../Boilerplate/TooltipIcon";
import PropTypes from "prop-types";

export class DeleteButton extends React.Component {
  state = { disabled: false };

  handleClick = bid => {
    if (!this.state.disabled) {
      this.setState({ disabled: true });
      message.info('Deleting bid ' + bid.resource.name);
      this.props.onDelete && this.props.onDelete(bid.resource.id);
    }
  };

  confirmDelete = bid => {
    Modal.confirm({
      title: 'Are you sure you want to delete this bid?',
      content: <span>If you delete this bid, it will be immediately removed from the system. This is an irreversible action.</span>,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => this.handleClick(bid),
    })
  };

  render() {
    return <a key={this.props.fauxKey} onClick={() => this.confirmDelete(this.props.bid)}>
      <TooltipIcon title={this.props.title} type={!this.state.disabled ? this.props.type : 'loading'}
                   theme={!this.state.disabled ? 'filled' : ''} iconStyle={{ fontSize: 22 }}/>
    </a>;
  }
}

DeleteButton.propTypes = {
  onDelete: PropTypes.func,
  fauxKey: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/Bids/DeleteButton.js